import { render, staticRenderFns } from "./MeetingStopper.vue?vue&type=template&id=4bf15060"
import script from "./MeetingStopper.vue?vue&type=script&lang=ts"
export * from "./MeetingStopper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports